import React, { forwardRef, memo } from 'react'
import styled from 'styled-components'

import constants from 'utils/constants'
import { formatPriceByLocale } from 'utils/utils'

import Button from 'components/presenters/button/Button'

export default memo(
  forwardRef(function StoreMainProdList({ prodList }, ref) {
    return (
      <StoreMainProdListBlock ref={ref}>
        {prodList?.map((product) => {
          const refundPrice = product.lowest_price - product.lowest_challenge_price
          const discountPercent = Math.round((refundPrice / product.lowest_price) * 100)
          return (
            <ProdItem key={`prod-list-no-${product?.no}`}>
              <Button to={`/motishop/product/${product.no}`}>
                <ProdBannerImgBlock>
                  <BannerImage
                    src={`${constants.imagePath}/commerce/product/banner_img/${product?.banner_img}`}
                  />
                </ProdBannerImgBlock>
                <ProdInfoBlock>
                  <ProdName>{product?.title}</ProdName>
                  <ProdPriceBlock>
                    {discountPercent ? (
                      <>
                        <DiscountPercent>{`${discountPercent}%`}</DiscountPercent>
                        <OriginalPrice>{`${formatPriceByLocale(
                          'ko',
                          product?.lowest_price,
                        )}원`}</OriginalPrice>
                      </>
                    ) : (
                      <OriginalPrice>{`${formatPriceByLocale(
                        'ko',
                        product?.lowest_price,
                      )}원`}</OriginalPrice>
                    )}
                    <RefundsPrice>{`${formatPriceByLocale(
                      'ko',
                      product?.lowest_challenge_price,
                    )}원`}</RefundsPrice>
                  </ProdPriceBlock>
                </ProdInfoBlock>
              </Button>
            </ProdItem>
          )
        })}
      </StoreMainProdListBlock>
    )
  }),
)

const StoreMainProdListBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

const ProdItem = styled.div`
  width: calc(100vw * (163 / 375));
  padding-bottom: calc(100vw * (23 / 375));
`

const ProdBannerImgBlock = styled.div`
  width: calc(100vw * (163 / 375));
  height: calc(100vw * (163 / 375));
  margin-bottom: calc(100vw * (14 / 375));
  overflow: hidden;
`

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: calc(100vw * (9 / 375));
  object-fit: cover;
`

const ProdInfoBlock = styled.div`
  width: 100%;
`

const ProdName = styled.h3`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  margin-bottom: calc(100vw * (4 / 375));
`

const ProdPriceBlock = styled.div`
  width: 100%;
`

const DiscountPercent = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 700;
  line-height: calc(100vw * (17 / 375));
  color: #ff6b00;
  margin-right: calc(100vw * (7 / 375));
`

const OriginalPrice = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  text-decoration-line: line-through;
  color: #c6c6c6;
`

const RefundsPrice = styled.p`
  font-size: calc(100vw * (16 / 375));
  font-weight: 700;
  line-height: calc(100vw * (19 / 375));
  color: #121212;
`
